import { render, staticRenderFns } from "./ContentModal.vue?vue&type=template&id=3345e156&"
import script from "./ContentModal.vue?vue&type=script&lang=js&"
export * from "./ContentModal.vue?vue&type=script&lang=js&"
import style0 from "./ContentModal.vue?vue&type=style&index=0&id=3345e156&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainVideo: require('/web/components/helpers/MainVideo.vue').default})
